import { createSelector } from 'reselect';

export const getParameterFileList = ({ parameterBackupV2 }) => {
    return parameterBackupV2?.parameterFileList;
};

export const getParameterFileTypeList = ({ parameterBackupV2 }) => {
    return parameterBackupV2?.parameterBackupTypes;
};

export const getParameterFileListLoadingStatus = ({ parameterBackupV2 }) => {
    return parameterBackupV2?.parameterFileList?.loadingStatus;
};

export const getParameterFileLoadingStatus = ({ parameterBackupV2 }) => {
    return parameterBackupV2?.parameterFile?.loadingStatus;
};

export const getParameterFile = ({ parameterBackupV2 }) => {
    return parameterBackupV2?.parameterFile;
};

export const getSelectedAsset = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedAsset;
};

export const getTriggerParameterBackupStatus = ({ parameterBackupV2 }) => {
    return parameterBackupV2?.triggerParameterBackupStatus;
};

export const getModel = createSelector([
    getParameterFileList,
    getParameterFileTypeList,
    getParameterFile,
    getSelectedAsset,
    getParameterFileListLoadingStatus,
    getParameterFileLoadingStatus,
    getTriggerParameterBackupStatus
],
    (
        parameterFileList,
        parameterFileTypeList,
        parameterFile,
        selectedAsset,
        parameterFileListLoadingStatus,
        parameterFileLoadingStatus,
        triggerParameterBackupStatus
    ) => {
        return {
            parameterFileList,
            parameterFileTypeList,
            parameterFile,
            selectedAsset,
            parameterFileListLoadingStatus,
            parameterFileLoadingStatus,
            triggerParameterBackupStatus
        };
    });
